'use client';

import React from 'react';
import Link from '@/components/atoms/link';
import { SectionHeaderProps } from './types';

const SectionHeader = ({ title, link, eyebrow, intro, variant = 'default' }: SectionHeaderProps) => {
  if (variant === 'editorial') {
    return (
      <div className="flex flex-col gap-4 pb-7 md:flex-row md:items-end md:justify-between lg:pb-9">
        <div className="max-w-2xl">
          {eyebrow && (
            <span className="text-12 text-primary mb-2 flex items-center gap-2 font-semibold tracking-wide uppercase">
              <span aria-hidden className="bg-primary inline-block size-1.5 rounded-full" />
              {eyebrow}
            </span>
          )}
          {title && <h2 className="text-22 lg:text-32 font-bold text-gray-800">{title}</h2>}
          {intro && <p className="text-14 lg:text-16 mt-3 leading-normal text-gray-600">{intro}</p>}
        </div>
        {link?.href && (
          <Link
            href={link.href}
            openInNewTab={link.openInNewTab}
            className="text-12 text-primary shrink-0 font-semibold tracking-wide uppercase"
            chevron
          >
            {link.name}
          </Link>
        )}
      </div>
    );
  }

  if (variant === 'centered') {
    return (
      <div className="mb-8 text-center lg:mb-10">
        {eyebrow && (
          <span className="text-12 text-primary mb-2 flex items-center justify-center gap-2 font-semibold tracking-wide uppercase">
            <span aria-hidden className="bg-primary inline-block size-1.5 rounded-full" />
            {eyebrow}
          </span>
        )}
        {title && <h2 className="text-22 lg:text-32 font-bold text-gray-800">{title}</h2>}
        {intro && <p className="text-14 lg:text-16 mx-auto mt-3 max-w-2xl leading-normal text-gray-600">{intro}</p>}
      </div>
    );
  }

  return (
    <div className="pt-8 pb-7 text-center lg:pt-12 lg:pb-9">
      {title && (
        <span data-testid="title-text" className="text-16 md:text-18 lg:text-24 font-bold text-gray-800">
          {title}
        </span>
      )}
      {link?.href && (
        <Link
          href={link.href ?? '#'}
          openInNewTab={link.openInNewTab}
          className="text-14 text-primary lg:text-16 mx-auto mt-4 p-1 font-medium"
          chevron
        >
          {link.name}
        </Link>
      )}
    </div>
  );
};

export default SectionHeader;
